/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelHighwayLoadLockAlerts.ts         *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/powerbroker/highway-load_lock-alerts";

export class AutogenModelHighwayLoadLockAlerts<RowType extends ModelRow> extends Endpoint<RowType, RowHighwayLoadLockAlertsFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowHighwayLoadLockAlerts extends ModelRow<RowHighwayLoadLockAlertsFields> {
	constructor(values?: Partial<RowHighwayLoadLockAlertsFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowHighwayLoadLockAlertsFields {
	ar_reason_code: string;
	attach_filename: string;
	attachment: string;
	carrier_id: string;
	comments: string;
	company_id: string;
	gps_accuracy: number;
	id: string;
	latitude: number;
	longitude: number;
	movement_id: string;
	order_id: string;
	parent_row_id: string;
	posted_by: string;
	posted_date: Date;
	posted_date_seconds: number;
	posted_type: string;
	reason_code: string;
	system_added: string;
}

